import PropTypes from 'prop-types';
import React from 'react';
import { Redirect } from 'react-router-dom';

// project imports
import useAuth from '../../hooks/useAuth';

//-----------------------|| AUTH GUARD ||-----------------------//

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const RoleGuard = ({ children, hasRole }) => {
    const { user } = useAuth();
    let role = user.roleNames[0];
    if (hasRole.indexOf(role) !== -1) {
        return null;
    }

    return children;
};

RoleGuard.propTypes = {
    children: PropTypes.node
};

export default RoleGuard;
